import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AmenitiesResponse } from '../models/interface/amenities-response.model';

const STORAGE_KEY = 'GLOBAL_AMENITIES';

@Injectable({
  providedIn: 'root'
})
export class GlobalAmenitiesService {

  private amenitiesSubject: BehaviorSubject<AmenitiesResponse | null> =
    new BehaviorSubject<AmenitiesResponse | null>(this.restore());

  readonly amenities$: Observable<AmenitiesResponse | null> =
    this.amenitiesSubject.asObservable();

  /* set once after login / api success */
  setAmenities(data: AmenitiesResponse): void {
    if (!data) return;

    this.amenitiesSubject.next(data);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

  /* sync access (use carefully) */
  getAmenities(): AmenitiesResponse | null {
    return this.amenitiesSubject.value;
  }

  /* quick guard check */
  hasAmenities(): boolean {
    return this.amenitiesSubject.value !== null;
  }

  /* clear on logout */
  clear(): void {
    this.amenitiesSubject.next(null);
    sessionStorage.removeItem(STORAGE_KEY);
  }

  /* restore on refresh */
  private restore(): AmenitiesResponse | null {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? (JSON.parse(raw) as AmenitiesResponse) : null;
    } catch {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
  }
}
